import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { RateAgreementBidPack } from "../RateAgreementBidPack";
import { rateAgreementBidPackWithIdQueryKey } from "./rateAgreementBidPackQueryKeys";

export const useFetchAvailableBidPacksForRateAgreement = (
  rateAgreementId: number | string | undefined
) => {
  return useQuery<Array<RateAgreementBidPack>, Error>({
    queryKey: rateAgreementBidPackWithIdQueryKey(rateAgreementId),
    queryFn: () => fetchAvailableBidPacksForRateAgreement(rateAgreementId),
    onError: () =>
      toast.error(
        `An error occurred when retrieving the Bid Packs for the Rate Agreement Id ${rateAgreementId}`
      ),
  });
};

const fetchAvailableBidPacksForRateAgreement = async (id: number | string | undefined) => {
  const { data: bidPacksForRateAgreement } = await axios.get<Array<RateAgreementBidPack>>(
    rateAgreementUrls.availableBidPacksForRateAgreement(id)
  );

  return bidPacksForRateAgreement;
};
